import { I18n } from '@calendly/i18n';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { CenteredEmptyState } from '../centered';
import { Divider } from './divider';
const containerCss = "c10ikkao";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});

// i18n-tasks-use t('publisher.empty_state.#{featureKey}.divider_text')
export const TemplatesEmptyState = ({
  contentKey,
  featureKey,
  children
}) => <Container data-testid="empty-state-templates">
    <CenteredEmptyState contentKey={contentKey} featureKey={featureKey} />
    <Divider>{I18n.t(`publisher.empty_state.${contentKey}.divider_text`)}</Divider>
    {children}
  </Container>;

require("./templates_empty_state.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./templates_empty_state.js");